exports.scrollIntoView_ = (element) => () => element.scrollIntoView();

exports.setTimeout = (delay) => (effect) => () => {
  return window.setTimeout(effect, delay);
};

exports.clearTimeout = (id) => () => {
  window.clearTimeout(id);
};
